<div class="ula-chart" *ngIf="data">
  <div #ulaHost [id]="$any(data).widgetId" class="ula-chart-host" [style.height]="hostHeight"></div>
</div>
